import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#__clip0_4672_2615)" }, [
      _createElementVNode("path", {
        d: "M8.99956 8.2875L12.7121 12L13.7726 10.9395L8.99956 6.1665L4.22656 10.9395L5.28706 12L8.99956 8.2875Z",
        fill: "currentColor"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "__clip0_4672_2615" }, [
        _createElementVNode("rect", {
          width: "18",
          height: "18",
          fill: "white"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }